import React from 'react';
import './ErrorPage.scss';
import SpinnerSga from '../UI/SpinnerSga';

const ErrorPage = ({ codeNumber, label }) => {
    return (
        <section className="error-page">
            <div className="description">
                <p className="gray-text">Błąd</p>
                <div className="container">
                    <p className="code">#{codeNumber}</p>
                    <p className="break-text">
                        <span>Wewnętrzy</span>
                        <span>{label}</span>
                    </p>
                </div>
                <p className="uppercase-text">Upps... coś poszło nie tak!</p>
                <p className="text">Wygląda na to, że aplikacja nie działa w prawidłowy sposób. </p>
                <p className="text">Nasz zespół pracuję nad rozwiązaniem problemu.</p>
                <p className="text padding-top">W międzyczasie zalecamy:</p>
                <ul className="todo_list">
                    <li className="list__item"><i className="material-icons">alarm</i> Poczekać chwilę</li>
                    <li className="list__item"><i className="material-icons">refresh</i> Odświeżyć stronę</li>
                </ul>
                <p className="text padding">W przypadku gdy problem nadal występuję prosimy o kontakt.</p>
                <address className="address">
                    <dl className="contact">
                        <dt className="contact__list">
                            <i className="material-icons">mail_outline</i> <a className="list__item" href="mailto:sga@sga.waw.pl">sga@sga.waw.pl</a>
                        </dt>
                        <dt className="contact__list">
                            <i className="material-icons">phone</i> <a className="list__item" href="tel:81-534-21-05">(81) 534 21 05</a>
                        </dt>
                    </dl>
                </address>
            </div>
            <SpinnerSga />
        </section>
    );
}

export default ErrorPage;